import React, { useState } from "react";
import { useSelector } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";
import constants from "../assets/js/constants";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";

function StaticTable({
  header,
  contentsRow,
  title,
  coloredColumnsBackgrounds = [],
  redBottomBorder,
  firstColumnWider,
}) {
  const [clickedRow, setClickedRow] = useState(null);
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <div style={{ position: "relative", width: "100%", overflowX: "auto" }}>
          {title && (
            <h3 className="static-table__title general-m-just-small-screen">
              {title}
            </h3>
          )}
          <table
            className="static-table"
            style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}
          >
            <thead
              className="static-table__header"
              // style={getVisibleSensorAnimation(
              //   isVisible,
              //   "background-appear 1s 1s forwards"
              // )}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: "#fbeee9",
                  zIndex: -1,
                  ...getVisibleSensorAnimation(
                    isVisible,
                    `${
                      generalSettings.rtlLanguage
                        ? "width-increase-flipped"
                        : "width-increase"
                    } 1s 1s backwards`
                  ),
                }}
              ></div>
              <tr className="static-table__row-heading">
                {header.map((headerItem, index) => (
                  <th
                    key={index}
                    className={`static-table__column-heading${setAdditionalClasses(
                      [
                        "static-table__first-column-heading",
                        "first-column-wider",
                      ],
                      [index === 0, firstColumnWider && index === 0]
                    )}`}
                  >
                    {headerItem.label.map((line, lineIndex) => (
                      <p
                        key={lineIndex}
                        className={`m-0${setAdditionalClasses(
                          ["no-wrap"],
                          [line && line.includes("SAR")]
                        )}`}
                      >
                        {line}
                      </p>
                    ))}
                    {/* {console.log(
                      "ss " + index + " " + headerItem.label[0] + "\n"
                    )} */}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="static-table__body">
              <div
                style={{
                  position: "absolute",
                  height: "2px",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: redBottomBorder
                    ? constants.COLORS.PRIMARY
                    : constants.COLORS.DARK_GRAY,
                  // zIndex: -1,
                  ...getVisibleSensorAnimation(
                    isVisible,
                    `${
                      generalSettings.rtlLanguage
                        ? "width-increase-flipped"
                        : "width-increase"
                    } 1s 1s backwards`
                  ),
                }}
              ></div>
              {contentsRow.map((content, index) => (
                <tr
                  className={`static-table__content-row${setAdditionalClasses(
                    ["clicked-row"],
                    [index === clickedRow]
                  )}`}
                  key={index}
                  onClick={() => setClickedRow(index)}
                >
                  {content.data.map((contentData, index) => (
                    <td
                      key={index}
                      className={`static-table__content-data${setAdditionalClasses(
                        [
                          "static-table__first-column-content",
                          "bold",
                          "bold",
                          "bold background-light-gray",
                          "redBottomBorder",
                          "first-column-wider",
                        ],
                        [
                          index === 0,
                          content.total,
                          content.bold,
                          coloredColumnsBackgrounds.includes(index),
                          content.redBottomBorder,
                          firstColumnWider && index === 0,
                        ]
                      )}`}
                    >
                      {contentData}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </VisibilitySensor>
  );
}

export default StaticTable;
